<template>
  <div component-name="card-store" class="flex flex-col @container/card-store">
    <divider />

    <div class="flex flex-col @md/card-store:flex-row gap-3xl py-3xl">
      <section class="@md/card-store:w-7/12 w-full">
        <media
          v-bind="asset"
          :loading="asset.loading || undefined"
          class="w-full"
          reveal="unveil-from-right"
        />
      </section>

      <section class="@md/card-store:w-5/12 w-full flex items-center">
        <div class="flex flex-col items-stretch gap-2xl">
          <header class="flex flex-col items-stretch w-full gap-2xs">
            <wrapper-reveal reveal="fade-from-right" class="w-full">
              <div
                class="w-full text-skin-base text-overline"
                v-html="overline"
              ></div>
            </wrapper-reveal>

            <wrapper-split-text reveal="chars" class="w-full max-w-full">
              <div class="text-skin-base text-heading-3" v-html="title"></div>
            </wrapper-split-text>
          </header>

          <div
            v-if="address || tel || email || openingTime"
            class="flex flex-col items-stretch w-full text-skin-base gap-md"
          >
            <div v-if="address" class="flex flex-col">
              <wrapper-reveal reveal="fade-from-bottom" class="w-full">
                <div
                  class="w-full text-skin-base text-overline/none"
                  v-html="$t.labels.address"
                ></div>
              </wrapper-reveal>

              <wrapper-reveal
                reveal="fade-from-bottom"
                class="w-full max-w-full"
              >
                <div
                  class="w-full text-skin-base text-body max-w-full"
                  v-html="finalAddress"
                ></div>
              </wrapper-reveal>
            </div>

            <div v-if="tel && telNumber" class="flex flex-col">
              <wrapper-reveal reveal="fade-from-bottom" class="w-full">
                <div
                  class="w-full text-skin-base text-overline/none"
                  v-html="$t.labels.tel"
                ></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom" class="w-full">
                <wrapper-reveal reveal="fade-from-bottom" class="w-full">
                  <btn
                    :title="tel"
                    :action="{ href: telNumber, tel: true }"
                    class="text-skin-base text-body"
                  >
                    <div v-html="tel"></div>
                  </btn>
                </wrapper-reveal>
              </wrapper-reveal>
            </div>

            <div v-if="openingTime" class="flex flex-col">
              <wrapper-reveal reveal="fade-from-bottom" class="w-full">
                <div
                  class="w-full text-skin-base text-overline/none"
                  v-html="$t.labels.opening_time"
                ></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom" class="w-full">
                <div
                  class="w-full text-skin-base text-body"
                  v-html="openingTime"
                ></div>
              </wrapper-reveal>
            </div>
          </div>

          <footer v-if="slug || email || directions" class="flex w-full gap-md">
            <wrapper-reveal v-if="slug || email" reveal="fade-from-right">
              <btn-pill
                v-if="slug"
                :title="$t.labels.find_out_more"
                :action="{ to: `/mirage-world/mirage-project-point/${slug}` }"
              />
              <btn-pill
                v-else
                :title="$t.labels.contacts"
                :action="{ href: email, email: true }"
                icon="email"
              />
            </wrapper-reveal>

            <wrapper-reveal v-if="directions" reveal="fade-from-right">
              <btn-pill
                :title="$t.labels.get_directions"
                :action="{ href: directions }"
                icon="store-locator"
              />
            </wrapper-reveal>
          </footer>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  slug: {
    type: String,
    required: false,
  },
  asset: {
    type: Object,
    required: true,
  },
  overline: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  address: {
    type: Object,
    required: true,
  },
  tel: {
    type: [String, Number],
    required: false,
  },
  email: {
    type: String,
    required: false,
  },
  openingTime: {
    type: String,
    required: false,
  },
  directions: {
    type: String,
    required: false,
  },
});

const telNumber = computed(() => {
  let n;

  if (props.tel) {
    n = props.tel.toString();
    n = n.replace(/\s+/g, "");
  }

  return n;
});

const finalAddress = computed(() => {
  if (!props.address) return null;
  const { street, postal_code, city, state_code, country } = props.address;

  let address = [];
  if (street) {
    address.push(street);
  }

  if (postal_code) {
    address.push(postal_code);
  }

  if (city) {
    address.push(state_code ? `${city} (${state_code})` : city);
  } else if (state_code) {
    address.push(state_code);
  }

  if (country) {
    address.push(country);
  }

  return address.join(", ");
});
</script>
